import { render, staticRenderFns } from "./publicannounce.vue?vue&type=template&id=99a1c9ce&scoped=true&"
import script from "./publicannounce.vue?vue&type=script&lang=js&"
export * from "./publicannounce.vue?vue&type=script&lang=js&"
import style0 from "./publicannounce.vue?vue&type=style&index=0&id=99a1c9ce&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a1c9ce",
  null
  
)

export default component.exports